export const baseMenu = [
  { icon: "mdi-home", text: "main", link: "/" },
  { icon: "mdi-account-clock", text: "Scheduler", link: "Scheduler" },
  { icon: "mdi-pill", text: "need", link: "Order", },
];

export const chatMenu = {
  id: "chat",
  icon: "mdi-chat",
  text: "farmChat",
  link: "Chat",
  badge: 0 // будем брать из Vuex
};

export const ordersMenu = {
  icon: "mdi-chevron-up",
  "icon-alt": "mdi-chevron-down",
  text: "orders",
  model: false,
  children: [
    { icon: "mdi-pill", text: "need", link: "Order" },
    { icon: "mdi-archive-arrow-down-outline", text: "archive", link: "ArchivePharmacy" },
    { icon: "mdi-sale", text: "discounts", link: "Discount" }
  ]
};

export const directoryMenu = {
  icon: "mdi-chevron-up",
  "icon-alt": "mdi-chevron-down",
  text: "directory",
  model: false,
  children: [
    { icon: "mdi-city-variant", text: "cities", link: "City" },
    { icon: "mdi-truck-delivery", text: "suppliers", link: "Distributor" },
    { icon: "mdi-hospital-box", text: "goods", link: "Goods" },
    { icon: "mdi-book-open", text: "annotation", link: "Annotation" },
    { icon: "mdi-note-multiple", text: "pricesMenu", link: "Price" },
    { icon: "mdi-account-group", text: "users", link: "User"}
  ]
};

export const controlMenu = {
  icon: "mdi-chevron-up",
  "icon-alt": "mdi-chevron-down",
  text: "control",
  model: false,
  children: [
    { icon: "mdi-account-supervisor-circle", text: "users", link: "UserControl" },
    { icon: "mdi-office-building", text: "companies", link: "CompanyControl" },
    { icon: "mdi-shield", text: "access", link: "AccessControl" },
    { icon: "mdi-shield-edit", text: "accessTemplate", link: "AccessTemplateControl" },
    { icon: "mdi-picture-in-picture-top-right", text: "advertising", link: "AdControl" },
    { icon: "mdi-script-text", text: "orders", link: "OrderControl" },
    { icon: "mdi-file-percent", text: "discountsAndContracts", link: "ContractControl" },
    { icon: "mdi-file-table", text: "shippingAddresses", link: "ShippingAddressControl" },
    { icon: "mdi-credit-card-settings", text: "halykCards", link: "HalykCardsControl" },
    { icon: "mdi-file-document-edit", text: "pricesMenu", link: "PriceControl" },
    { icon: "mdi-truck-delivery", text: "suppliers", link: "DistributorControl" },
    { icon: "mdi-console", text: "Hangfire", link: "Hangfire" },
    { icon: "mdi-book-information-variant", text: "apirequest", link: "apirequestcontrol" },
    { icon: "mdi-newspaper-variant-outline", text: "news", link: "Article" },
    { icon: "mdi-shield-account", text: "UserAccess", link: "UserAccessControl" }
  ]
};

export const settingsMenu = {
  icon: "mdi-chevron-up",
  "icon-alt": "mdi-chevron-down",
  text: "setting",
  model: false,
  children: [
    { icon: "mdi-album", text: "priorities", link: "FilialLine", },
    { icon: "mdi-cog", text: "generalSettings", link: "UserSettings", },
  ],
};

export const reportsMenu = {
  icon: "mdi-chevron-up",
  "icon-alt": "mdi-chevron-down",
  text: "reports",
  model: false,
  children: [
    { icon: "mdi-chart-bar", text: "priceMonitoring", link: "PriceAnalysisReport", },
    { icon: "mdi-chart-bar", text: "averagePriceReport", link: "AveragePriceShareSalesReport", },
  ],
}

// Утилита для клонирования и удаления элементов по text
export function cloneMenu(menu, exclude = []) {
  return {
    ...menu,
    children: menu.children.filter(c => !exclude.includes(c.text))
  }
}